import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/common';

import { PersonalVisitListComponent } from './component/personal-visit-list.component';
import { CommonLayoutModule } from '@sdbn/common';
import { MatTableModule as MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';

@NgModule({
  declarations: [
    PersonalVisitListComponent
  ],
  imports: [
    CommonModule,
    DictionaryModule,

    CommonTranslationModule,
    CommonLayoutModule,
    CommonUIModule,
    MatTableModule,
    MatSortModule
  ],
  exports: [
    PersonalVisitListComponent
  ]
})
export class PersonalVisitListModule { }
